export function findMasterData<T = undefined>(masterDataMap: Map<string, {}>, key: string): T | undefined {
  if (masterDataMap.has(key)) {
    return masterDataMap.get(key) as T;
  }
  return undefined;
}
